import calendarReducer, { CalendarState } from './@interface/calendar/calendarReducer'
import pacoAbsenceReducer, { AbsencesState } from './absences/absencesReducer'
import pacoAppReducer, { AppState } from './app/appReducer'
import hourBalancesReducer, { HourBalancesState } from './hourBalances/hourBalancesReducer'
import pacoLeaveOfAbsenceRequestDetailReducer, { LeaveOfAbsenceRequestDetailState } from './leaveOfAbsenceRequestDetail/leaveOfAbsenceRequestDetailReducer'
import pacoLeaveOfAbsencesRequestsReducer, { LeaveOfAbsencesRequestsState } from './leaveOfAbsencesRequests/leaveOfAbsencesRequestsReducer'
import pacoRegistrationReducer, { RegistrationState } from './registration/registrationReducer'
import pacoShiftsReducer, { ShiftsState } from './shifts/shiftsReducer'
import pacoSpecialDaysReducer, { SpecialDaysState } from './specialDays/specialDaysReducer'
import toastsReducer, { ToastsState } from './toasts/toastsReducer'
import transportationOptionsReducer, { TransportationOptionsState } from './transportationOptions/transportationOptionsReducer'
import yearEndStatementReducer, { YearEndStatementsState } from './yearEndStatement/yearEndStatementReducer'


export interface Reducers {
    calendarReducer: CalendarState;
    hourBalancesReducer: HourBalancesState;
    pacoAppReducer: AppState;
    pacoRegistrationReducer: RegistrationState;
    pacoShiftsReducer: ShiftsState;
    pacoSpecialDaysReducer: SpecialDaysState;
    toastsReducer: ToastsState;
    transportationOptionsReducer: TransportationOptionsState;
    yearEndStatementReducer: YearEndStatementsState;
    pacoAbsenceReducer: AbsencesState;
    pacoLeaveOfAbsencesRequestsReducer: LeaveOfAbsencesRequestsState;
    pacoLeaveOfAbsenceRequestDetailReducer: LeaveOfAbsenceRequestDetailState;
}

export default {
    calendarReducer,
    hourBalancesReducer,
    pacoAppReducer,
    pacoRegistrationReducer,
    pacoShiftsReducer,
    pacoSpecialDaysReducer,
    toastsReducer,
    transportationOptionsReducer,
    yearEndStatementReducer,
    pacoAbsenceReducer,
    pacoLeaveOfAbsencesRequestsReducer,
    pacoLeaveOfAbsenceRequestDetailReducer,
}
